import React from 'react';

interface SearchIconProps extends React.SVGProps<SVGSVGElement> {
	width?: number;
	height?: number;
	fill?: string;
}

export function SearchIcon({ width = 16, height = 16, fill = 'currentColor', ...props }: Readonly<SearchIconProps>) {
	return (
		<svg
			{...props}
			fill="none"
			width={width}
			height={height}
			viewBox="0 0 16 16"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9.458 3.27462C10.9639 4.80103 11.1319 7.18367 9.93193 8.88575C9.87527 8.96613 9.81555 9.045 9.75278 9.12218C9.73354 9.14583 9.71402 9.16933 9.69422 9.19266L9.94852 9.44771C9.95756 9.44228 9.96669 9.43698 9.9759 9.43181C10.0608 9.38424 10.1529 9.34813 10.2487 9.3235C10.3516 9.29703 10.4589 9.28379 10.5663 9.28379C10.9115 9.28379 11.2384 9.42935 11.4746 9.66605L13.6184 11.7784C14.1272 12.2883 14.1272 13.1076 13.6184 13.6175C13.3822 13.8724 13.0553 14 12.7099 14C12.3647 14 12.0379 13.8542 11.8017 13.6175L9.65782 11.4689C9.32058 11.1457 9.20821 10.6683 9.32048 10.2377C9.34504 10.1435 9.38034 10.0515 9.42638 9.96391C9.43072 9.95565 9.43516 9.94742 9.43969 9.93924L9.18539 9.68441C9.1584 9.70768 9.13116 9.73058 9.10366 9.7531C9.03147 9.81225 8.95753 9.86883 8.88199 9.92281C8.15335 10.4435 7.27534 10.7223 6.36931 10.7223C5.20674 10.7223 4.09844 10.2671 3.28083 9.44771C1.57306 7.75413 1.57306 4.98634 3.28083 3.27462C4.11653 2.45525 5.20674 2 6.36931 2C7.53209 2 8.64039 2.45525 9.458 3.27462ZM8.55123 8.57229C9.78305 7.35316 9.78305 5.38731 8.55123 4.16818L8.54897 4.16594C7.93791 3.55364 7.14279 3.24273 6.35122 3.24273C5.55986 3.24273 4.76333 3.55359 4.15137 4.15011C2.93672 5.36995 2.9375 7.3557 4.15371 8.57456C4.76452 9.1868 5.55964 9.49774 6.35122 9.49774C7.14279 9.49774 7.93791 9.18684 8.54897 8.57453L8.55123 8.57229Z"
				fill={fill}
			/>
		</svg>
	);
}
